import React from 'react'

const CopyRight = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative w-full overflow-hidden">
      {/* Animated divider */}
      <div className="section-divider-animated" />

      <div className="bg-primary-dark py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-center text-gray text-sm">
            &copy; {currentYear}{' '}
            <span className="text-accent font-medium">Nang Myintzu</span>. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default CopyRight
